// File: src/components/layouts/wrappers/LayoutWrapper.tsx

import React from "react";
import styled from "styled-components";

interface LayoutWrapperProps {
  children: React.ReactNode;
  maxWidth?: string;
  fullHeight?: boolean;
  noPadding?: boolean;
}

const Wrapper = styled.div<{ fullHeight?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: ${({ fullHeight }) => (fullHeight ? "100vh" : "auto")};
  width: 100%;
`;

const Inner = styled.main<{ maxWidth?: string; noPadding?: boolean }>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || "1200px"};
  margin: 0 auto;
  flex: 1;
  padding: ${({ noPadding, theme }) =>
    noPadding ? "0" : `${theme.spacing.lg} ${theme.spacing.md}`};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: ${({ noPadding, theme }) =>
      noPadding ? "0" : `${theme.spacing.md} ${theme.spacing.sm}`};
  }
`;

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  children,
  maxWidth,
  fullHeight = true,
  noPadding = false,
}) => {
  return (
    <Wrapper fullHeight={fullHeight}>
      <Inner maxWidth={maxWidth} noPadding={noPadding}>
        {children}
      </Inner>
    </Wrapper>
  );
};
